import { createSelector } from "@reduxjs/toolkit";
import { RootStateOrAny } from "react-redux";
import { StepFormState } from "./types";

export const stepFormSelector = createSelector(
    (state: RootStateOrAny) => state.stepForm,
    (state: StepFormState) => state
);
